<template>
    <div
        v-if="isVisible"
        :class="{
            alert: true,
            [`alert--${variant}`]: variant,
        }"
    >
        <div class="alert__wrapper">
            <div class="alert__content">
                <!-- @slot Content message. -->
                <slot></slot>
            </div>
            <div class="alert__close-btn" @click="onCloseBtnClick">
                <generic-close-big class="alert__icon" />
            </div>
        </div>
    </div>
</template>

<script>
import GenericCloseBig from '@motork/shift-assets/dist/svg/icons/generic-close--big.svg';

export default {
    name: 'Alert',
    components: {
        GenericCloseBig,
    },
    props: {
        /**
         * Theme variant. Availables: `error`.
         */
        variant: {
            type: String,
            default: '',
        },
        /**
         * Show or hide.
         */
        show: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isVisible: this.show,
        };
    },
    watch: {
        show(newValue) {
            this.isVisible = newValue;
        },
    },
    methods: {
        onCloseBtnClick() {
            this.isVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/scss/abstract/_variables.scss';
@import '@/scss/abstract/_mixins.scss';
@import '@/scss/molecules/_alert.scss';
</style>
